import { jsx as _jsx } from "react/jsx-runtime";
import { Scripts as TTArkScripts, UNSAFE_RemixContext } from '@ttark/components';
import { useAtomValue } from 'jotai';
import { $RenderConfig } from '../atom';
import { useContext } from 'react';
export const Scripts = () => {
    const { disableInlineScripts } = useAtomValue($RenderConfig);
    const isSpaMode = useContext(UNSAFE_RemixContext)?.isSpaMode;
    return _jsx(TTArkScripts, { hasCSPRequirement: isSpaMode || disableInlineScripts });
};
